import api from './api';

export const getNeighborhoodDevelopments = async () => {
  try {
    const response = await api.get('/api/NeighborhoodDevelopment/All');
    return response;
  } catch (error) {
    if (error.response && error.response.data) {
      throw error.response.data;
    }
    throw error;
  }
};

export const getNeighborhoodDevelopmentByGuid = async (guid) => {
  try {
    const response = await api.post('/api/NeighborhoodDevelopment/GetByGuid', { guid });
    return response;
  } catch (error) {
    if (error.response && error.response.data) {
      throw error.response.data;
    }
    throw error;
  }
};

export const addNeighborhoodDevelopment = async (data) => {
  try {
    const response = await api.post('/api/NeighborhoodDevelopment/Add', data);
    return response;
  } catch (error) {
    if (error.response && error.response.data) {
      throw error.response.data;
    }
    throw error;
  }
};

export const updateNeighborhoodDevelopment = async (data) => {
  try {
    const response = await api.post('/api/NeighborhoodDevelopment/Update', data);
    return response;
  } catch (error) {
    if (error.response && error.response.data) {
      throw error.response.data;
    }
    throw error;
  }
};

export const deleteNeighborhoodDevelopment = async (guid) => {
  try {
    const response = await api.post('/api/NeighborhoodDevelopment/Delete', { guid });
    return response;
  } catch (error) {
    if (error.response && error.response.data) {
      throw error.response.data;
    }
    throw error;
  }
};
